import { registerBlockType } from "@wordpress/blocks";
import config from "./block.json";
import TeacherHeaderEditor from "./TeacherHeaderEditor";
import { InnerBlocks } from "@wordpress/block-editor";

registerBlockType(config.name, {
  ...config,
  edit: TeacherHeaderEditor,
  save() {
    return <InnerBlocks.Content />;
  },
});
